module.exports = __webpack_public_path__ + "static/media/create-your-packages@3x.1127bd91.png";